import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

interface StyledIconProps {
  small?: boolean;
}

interface MenuProps {
  admin?: boolean;
  active?: boolean;
}

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;

  width: ${({ theme }) => theme.desktop.menu.itemWidth}px;
  transition: width ease-in-out 0.5s;
  overflow: hidden;

  position: fixed;
  z-index: 2;
  top: ${({ theme }) => theme.desktop.header.height}px;
  left: 0;

  &:hover {
    width: ${({ theme }) => theme.desktop.menu.expandedWidth}px;

    & > button {
      border-bottom: 1px solid rgba(${ColorPalette.RGB.Black}, 5%);
    }
  }
`;

export const MenuItem = styled.button<MenuProps>`
  display: flex;
  align-items: center;
  cursor: pointer;

  background: ${({ admin, active }) => {
    if (active) return ColorPalette.HEX.RedPigment2;
    if (admin) return ColorPalette.HEX.Seashell;
    return ColorPalette.HEX.Cultured4;
  }};

  transition: border-color ease-in-out 0.5s;
  border-bottom: 1px solid ${ColorPalette.Transparent};
  &:last-child {
    border-bottom: none !important;
  }

  & > * {
    transition: opacity ease-in-out 0.5s;
  }

  &:hover {
    & > * {
      opacity: 60%;
    }
  }
`;

export const MenuIcon = styled.div<MenuProps>`
  display: flex;
  align-items: center;
  justify-content: center;

  width: ${({ theme }) => theme.desktop.menu.itemWidth}px;
  min-width: ${({ theme }) => theme.desktop.menu.itemWidth}px;
  height: ${({ theme }) => theme.desktop.menu.itemHeight}px;

  background: ${({ theme, admin, active }) => {
    if (active) return `${theme.button.background}`;
    if (admin) return ColorPalette.HEX.Seashell;
    return ColorPalette.HEX.Cultured4;
  }};

  img {
    filter: ${({ active }) => (active ? 'brightness(100)' : 'none')};
  }

  @media only screen and (max-height: 849px) {
    height: ${({ theme }) => theme.desktop.menu.smallItemHeight}px;
  }
`;

export const MenuName = styled.span<MenuProps>`
  display: flex;
  flex: 1;
  align-items: center;
  padding-left: 16px;
  font-size: 16px;
  white-space: nowrap;

  height: ${({ theme }) => theme.desktop.menu.itemHeight}px;

  background: ${({ admin, active }) => {
    if (active) return ColorPalette.HEX.RedPigment2;
    if (admin) return ColorPalette.HEX.Seashell;
    return ColorPalette.HEX.Cultured4;
  }};
  color: ${({ active }) => (active ? ColorPalette.HEX.White : 'inherit')};
  font-weight: ${({ active }) => (active ? 'bold' : 'normal')};

  @media only screen and (max-height: 849px) {
    height: ${({ theme }) => theme.desktop.menu.smallItemHeight}px;
  }
`;

export const Icon = styled.img.attrs<any, StyledIconProps>({})`
  width: 46px;
  height: ${({ small }) => (small ? '22px' : '40px')};

  @media only screen and (max-height: 849px) {
    height: ${({ small }) => (small ? '16px' : '30px')};
  }
`;
